import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { AGREEMENTS_URLS } from '@banking/ui/utils/constants';
import { ROUTE_FOR_STATUS } from '@banking/savings-onboarding-app/utils/signup/route-for-application-status';

export default class SignupIndexController extends Controller {
  @tracked isLoading = false;
  @service currentApplicationFlow;
  @service router;
  @service savingsApy;

  get privacyPolicyLink() {
    return AGREEMENTS_URLS.privacyPolicyLink;
  }

  get currentYear() {
    return new Date().getFullYear();
  }

  @action async submit() {
    this.isLoading = true;
    try {
      // if we already have an app flow, don't request a new one:
      if (!this.currentApplicationFlow.applicationFlow) {
        await this.currentApplicationFlow.create();
      }

      const route = ROUTE_FOR_STATUS[this.currentApplicationFlow.status];
      if (!route) {
        new Error(`unexpected ApplicationFlow status: ${status}`);
      }
      this.router.transitionTo(route);
    } catch (error) {
      this.send('handleRpcError', error);
    } finally {
      this.isLoading = false;
    }
  }
}
